module.exports = __webpack_public_path__ + "img/vertical_7_7_3009.b9db855e.png";